import Search from './Search'
import Times from './Times'
import Media from './Media'
import Marker from './Marker'
import ArrowDown from './ArrowDown'
import Globe from './Globe'
import Phone from './Phone'
import Envelope from './Envelope'
import Facebook from './Facebook'
import Line from './Line'
import User from './User'
import Home from './Home'
import TimeCircle from './TimeCircle'
import Pen from './Pen'
import ChevronCircleRight from './ChevronCircleRight'
import FileAlt from './FileAlt'
import ChevronLeft from './ChevronLeft'
import ChevronRight from './ChevronRight'
import TicketAlt from './TicketAlt'
import Reward from './Reward'
import Hotel from './Hotel'
import Plus from './Plus'
import MinusCircle from './MinusCircle'
import Radar from './Radar'
import MoneyBill from './MoneyBill'
import Star from './Star'
import Clock from './Clock'
import CheckCircle from './CheckCircle'
import CalendarDay from './CalendarDay'
import MenuBar from './MenuBar'
import Calendar from './Calendar'
import Check from './Check'
import Office from './Office'
import ClockSolid from './ClockSolid'
import CalendarDaySolid from './CalendarDaySolid'
import CalendarSolid from './CalendarSolid'
import ClipboardCheck from './ClipboardCheck'
import Wrench from './Wrench'
import Coupon from './Coupon'
import Tooltips from './Tooltips'
import File from './File'
import Instragram from './Instragram'
import Tiktok from './Tiktok'
import Youtube from './Youtube'
import ArrowUp from './ArrowUp'
import ArrowRightShort from './ArrowRightShort'
import PhoneCall from './PhoneCall'
import ScrewdriverWrench from './ScrewdriverWrench'
import Lightbulb from './Lightbulb'
import Briefcase from './Briefcase'
import Usertie from './Usertie'
import Percent from './Percent'
import House from './House'
import LocationDot from './LocationDot'

export default {
  Search,
  Times,
  Media,
  Marker,
  ArrowDown,
  Globe,
  Phone,
  Envelope,
  Facebook,
  Line,
  User,
  Home,
  TimeCircle,
  Pen,
  ChevronCircleRight,
  FileAlt,
  ChevronRight,
  ChevronLeft,
  TicketAlt,
  Reward,
  Hotel,
  Plus,
  MinusCircle,
  Radar,
  MoneyBill,
  Star,
  Clock,
  CheckCircle,
  CalendarDay,
  MenuBar,
  Calendar,
  Check,
  Office,
  ClockSolid,
  CalendarDaySolid,
  CalendarSolid,
  ClipboardCheck,
  Wrench,
  Coupon,
  Tooltips,
  File,
  Instragram,
  Tiktok,
  Youtube,
  ArrowUp,
  ArrowRightShort,
  PhoneCall,
  ScrewdriverWrench,
  Lightbulb,
  Briefcase,
  Usertie,
  Percent,
  House,
  LocationDot,
}
